export default __webpack_public_path__ + "static/media/sidebar-close.dfdd8ae5.svg";